export default __webpack_public_path__ + "static/media/ImagePlaceholder.905ffd2a.svg";